import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-duration',
  imports: [CommonModule],
  templateUrl: './duration.component.html',
  styleUrls: ['./duration.component.scss'],
})
export class DurationComponent implements OnInit {
  @Input() duration: string;
  @Input() showDuration: boolean; // Show duration by default
  @Input() iconColor: string;
  @Input() iconSize: string;
  @Input() showIcon: boolean;
  @Input() iconClass: string;

  constructor() {}

  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
